import Loading from './components/Loading'
import { colors } from '@/assets/colors'
import { lightTheme } from './customTheme'
import { useTranslation } from 'react-i18next'
import ColorPaletteGrid from '@/components/ColorPaletteGrid'
import type { ColorPickerPopoverPlacement } from '@/components/ColorPaletteGrid'

interface props {
  style?: React.CSSProperties
  onItemSelected: (color: string) => void
  onFinalItemSelected?: (color: string) => void
  colorSelected: string | null
  isPopover?: boolean
  popoverPlacement?: ColorPickerPopoverPlacement
  popoverOffset?: { x?: number; y?: number }
  title?: string | null
}

function ColorsPackContainer({ 
  style, 
  onItemSelected, 
  onFinalItemSelected,
  colorSelected, 
  isPopover = false, 
  popoverPlacement = 'right',
  popoverOffset,
  title = 'Colors',
}: props) {
  const handleColorChange = (color: string, isFinal: boolean) => {
    onItemSelected(color)
    if(isFinal) {
      onFinalItemSelected?.(color)
    }
  }
  const { t } = useTranslation()

  const paletteColors = colors.slice(0, 11).map((c: { color: string }) => c.color)
  const pickerColor = colors[11]?.color

  return (
    <div style={{ ...style }} className={isPopover ? "" : "mt-50"}>
      {title && <div
        style={{
          width: '100%',
          height: '26px',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        <span style={{ ...lightTheme.typography.Small14Semibold, color:lightTheme.colors.text.text_black_title }}>{t(title)}</span>
      </div>}

      {colors && colors.length > 0 ? (
        <ColorPaletteGrid
          colors={paletteColors}
          selectedColor={colorSelected}
          onChange={handleColorChange}
          showPickerButton={!!pickerColor}
          pickerConfig={{ placement: popoverPlacement, offset: popoverOffset }}
          isSecondaryStyle={isPopover}
        />
      ) : (
        <Loading />
      )}
    </div>
  )
}

export default ColorsPackContainer
